import { incYenOf } from '../../../lib/pricing';
const home = {
  // HeroSection
  'home.hero.badge': 'Operated by The All Japan Butler Association',
  'home.hero.title': 'Japan\'s Only Institution for ',
  'home.hero.titleAccent': 'Professional Butler Training.',
  'home.hero.subtitle': 'The Japan Butler Academy',
  'home.hero.description': 'Where the traditions of British butler culture meet the spirit of Japanese hospitality — world-class butler education, from Odaiba.',
  'home.hero.ctaBrochure': 'Request a Brochure',
  'home.hero.ctaConsultation': 'Book a Consultation',
  'home.hero.ctaPersonal': 'For Individuals',
  'home.hero.ctaCorporate': 'For Companies',
  'home.hero.imgAlt': 'The Japan Butler Academy — a butler standing with poise and dignity',
  'home.hero.imgTitle': 'The Japan Butler Academy — butler in formal attire',

  // AudienceSplitSection
  'home.audienceSplit.label': 'FOR INDIVIDUALS & COMPANIES',
  'home.audienceSplit.title': 'For Individuals & For Companies',
  'home.audienceSplit.subtitle': 'We offer tailored guidance for individual students who attend our campus as learners, and for corporate clients whose teams we train on-site at their own workplace.',
  'home.audienceSplit.personal.tag': 'For Individuals',
  'home.audienceSplit.personal.tagEn': 'For Individuals',
  'home.audienceSplit.personal.title': 'Campus-Based Butler Training Courses',
  'home.audienceSplit.personal.desc': 'An in-person educational programme at our Odaiba campus in Tokyo, where you systematically learn butler deportment from the fundamentals. Held on weekends in small classes (max. 6 students), with three courses to suit your goals.',
  'home.audienceSplit.personal.point1': 'In-person classes at our Odaiba campus, Tokyo',
  'home.audienceSplit.personal.point2': 'Weekend classes, small groups (max. 6 students)',
  'home.audienceSplit.personal.point3': 'Three courses: Essential / Advanced / Master',
  'home.audienceSplit.personal.cta': 'For Individuals',
  'home.audienceSplit.personal.imgAlt': 'Two trainees writing notes at the long dining table',
  'home.audienceSplit.corporate.tag': 'For Companies',
  'home.audienceSplit.corporate.tagEn': 'For Companies',
  'home.audienceSplit.corporate.title': 'On-Site Corporate Training',
  'home.audienceSplit.corporate.desc': 'A dispatch-style training programme where our professional butler instructors travel to your workplace anywhere in Japan. Eight sector-specific programmes, spanning hotels, finance, and luxury retail, raise the standard of hospitality on your floor.',
  'home.audienceSplit.corporate.point1': 'On-site nationwide (academy-based training also available)',
  'home.audienceSplit.corporate.point2': 'Eight sector-specific programmes',
  'home.audienceSplit.corporate.point3': 'Hands-on training, half-day or full-day',
  'home.audienceSplit.corporate.cta': 'For Companies',
  'home.audienceSplit.corporate.imgAlt': 'Corporate training participants in a company meeting room',

  // AudienceBandHeader
  'home.audienceBand.personal.tagEn': 'For Individuals',
  'home.audienceBand.personal.title': 'For Individuals — Our Campus-Based Programme in Odaiba',
  'home.audienceBand.personal.lead': 'A weekend, in-person programme at our Odaiba campus in Tokyo, designed for working adults. Below, we introduce our courses, curriculum, and learning environment.',
  'home.audienceBand.personal.cta': 'For Individuals',
  'home.audienceBand.corporate.tagEn': 'For Companies',
  'home.audienceBand.corporate.title': 'For Companies — On-Site Butler Training Programme',
  'home.audienceBand.corporate.lead': 'Our instructors travel to your workplace. Training can be delivered in an external meeting room or on-site, including outdoor and field-based sessions, and can be customised by industry.',
  'home.audienceBand.corporate.cta': 'For Companies',

  // AboutSection
  'home.about.label': 'The All Japan Butler Association',
  'home.about.title': 'Japan\'s Only Authentic Butler Training Institution',
  'home.about.subtitleEn': 'About The Japan Butler Academy',
  'home.about.body1': 'The Japan Butler Academy is operated by ',
  'home.about.body1Bold': 'The All Japan Butler Association',
  'home.about.body1End': ', the only institution in Japan dedicated to authentic butler training.',
  'home.about.body2': 'We offer a distinctive curriculum that blends the time-honoured techniques of British butler tradition with the advanced hospitality management demanded by modern society.',
  'home.about.body3': 'As a newly established educational institution, we are committed to nurturing world-class professional butlers through both tradition and innovation.',
  'home.about.body4': 'We keep classes small, with no more than six students each, so instructors can attend to the deportment of every student. \n\nBy combining weekend in-person lessons with on-demand video for preparation and review, we have created an environment where you can pursue world-class butler education while continuing to work.',
  'home.about.body5': 'Learning takes place at our Odaiba campus in Tokyo, whose atmosphere evokes the lobby of a luxury hotel. There you will systematically master tea service, table setting, and the art of the escort through hands-on practice. \n\nNot selling, but welcoming with grace — we convey the essence of the butler through both tradition and practice.',
  'home.about.sub2': 'A Distinctive Curriculum Fusing Tradition and Innovation',
  'home.about.sub4': 'Small Classes and Hybrid Learning',
  'home.about.sub5': 'Our Main Campus in Odaiba, Tokyo',
  'home.about.sub2.imgAlt': 'White-gloved hands folding a napkin into a fan on the dining table',
  'home.about.sub4.imgAlt': 'Young female trainee carrying a silver tray with three water glasses',
  'home.about.sub5.imgAlt': 'Female trainee polishing and checking a wine glass in the dining room',
  'home.about.cta': 'Learn more about the Academy',

  // CoursesSection
  'home.courses.label': 'COURSES',
  'home.courses.title': 'Our Courses',
  'home.courses.schedule': 'All courses held on',
  'home.courses.scheduleDetail1': 'Weekends',
  'home.courses.scheduleDetail2': '6 hours per day',
  'home.courses.scheduleDetail3': 'Small-group classes',
  'home.courses.scheduleDetail3Sub': '(max. 6 students)',
  'home.courses.scheduleConnector1': ' · ',
  'home.courses.scheduleConnector2': '(4 x 90-min sessions) · ',
  'home.courses.periodLabel': 'Duration',
  'home.courses.hoursLabel': 'Total Hours',
  'home.courses.daysLabel': 'Class Days',
  'home.courses.priceLabel': 'Tuition',
  'home.courses.taxNote': '(tax incl.)',
  'home.courses.viewDetail': 'View Course Details',
  'home.courses.scheduleLink': 'View Annual Schedule',
  // Course image alt/title
  'home.courses.essential.imgAlt': 'Female instructor checking tableware placement with a ruler in the dining room',
  'home.courses.essential.imgTitle': 'Female instructor checking tableware placement with a ruler in the dining room',
  'home.courses.advanced.imgAlt': 'Young female trainee pouring tea for a female instructor playing the guest',
  'home.courses.advanced.imgTitle': 'Young female trainee pouring tea for a female instructor playing the guest',
  'home.courses.master.imgAlt': 'Young male trainee bowing before double doors as an instructor watches',
  'home.courses.master.imgTitle': 'Young male trainee bowing before double doors as an instructor watches',
  // Essential
  'home.courses.essential.tag': 'ESSENTIAL COURSE',
  'home.courses.essential.title': 'Essential Course',
  'home.courses.essential.desc': 'An introductory course to acquire the fundamental knowledge and skills of a butler — from table manners to core service techniques — building a solid foundation.',
  'home.courses.essential.period': '1 Month',
  'home.courses.essential.hours': '48 Hours',
  'home.courses.essential.days': '8 Days',
  'home.courses.essential.price': `¥${incYenOf('ac-essential')}`,
  'home.courses.essential.target': 'For beginners and career changers',
  'home.courses.essential.cert': 'Graduates receive the Certified Associate Butler credential',
  // Advanced
  'home.courses.advanced.tag': 'ADVANCED COURSE',
  'home.courses.advanced.title': 'Advanced Course',
  'home.courses.advanced.desc': 'An intermediate course that includes the full content of the Essential course, then builds toward practical service techniques and advanced hospitality management, including wine service and event coordination. Open to complete beginners.',
  'home.courses.advanced.period': '2 Months',
  'home.courses.advanced.hours': '72 Hours',
  'home.courses.advanced.days': '12 Days',
  'home.courses.advanced.price': `¥${incYenOf('ac-advanced')}`,
  'home.courses.advanced.target': 'For those with foundational knowledge seeking skill advancement',
  'home.courses.advanced.cert': 'Graduates receive the Certified Professional Butler credential',
  // Master
  'home.courses.master.tag': 'MASTER COURSE',
  'home.courses.master.title': 'Master Course',
  'home.courses.master.desc': 'The premier course, including the full content of both the Essential and Advanced courses, mastering the full spectrum of butler expertise and management, from household management to client consultation. Open to complete beginners.',
  'home.courses.master.period': '3 Months',
  'home.courses.master.hours': '96 Hours',
  'home.courses.master.days': '16 Days',
  'home.courses.master.price': `¥${incYenOf('ac-master')}`,
  'home.courses.master.target': 'For aspiring professionals and those seeking management roles',
  'home.courses.master.cert': 'Graduates receive the Certified Master Butler credential',

  // CurriculumSection
  'home.curriculum.label': 'CURRICULUM',
  'home.curriculum.title': 'Curriculum Highlights',
  'home.curriculum.subtitle': 'Three pillars — theory, practice, and structured learning — build genuine capability.',
  'home.curriculum.theory.title': 'Theory Meets Practice',
  'home.curriculum.theory.body': 'We balance the traditional theoretical framework of British butler culture with practical skills suited to contemporary society — reinforcing the fundamentals in class and developing readiness in hands-on training.',
  'home.curriculum.roleplay.title': 'Role-Playing Training',
  'home.curriculum.roleplay.body': 'Studio role-playing sessions modelled on real residences and luxury hotels prepare students for a diverse range of situations, sharpening their real-world response skills.',
  'home.curriculum.structured.title': 'Structured Learning with Specialist Textbooks',
  'home.curriculum.structured.body': 'Using textbooks supervised by The All Japan Butler Association, students acquire knowledge systematically. The comprehensive materials remain valuable references even after graduation.',
  'home.curriculum.cta': 'View Curriculum Details',

  // BenefitsSection
  'home.benefits.label': 'BENEFITS & CERTIFICATE',
  'home.benefits.title': 'Course Benefits & Certificate',
  'home.benefits.subtitle': 'Every course includes a comprehensive range of benefits, and graduates receive an official certificate from The All Japan Butler Association. Benefits vary by course.',
  'home.benefits.cta': 'View Tuition & Benefits',

  // FacilityAccessSection
  'home.facility.label': 'FACILITY & ACCESS',
  'home.facility.title': 'Facilities & Access',
  'home.facility.mainCampus': 'Main Campus (Odaiba)',
  'home.facility.postal': '135-0064',
  'home.facility.address': '2-7-4 Aomi, Koto-ku, Tokyo',
  'home.facility.station1': 'Yurikamome Line "',
  'home.facility.station1Name': 'Tokyo International Cruise Terminal Station',
  'home.facility.station1End': '" approx. 5 min walk',
  'home.facility.station2': 'Yurikamome Line "',
  'home.facility.station2Name': 'Telecom Center Station',
  'home.facility.station2End': '" approx. 5 min walk',
  'home.facility.reservationNote': '* Campus visits are available by prior reservation only.',
  'home.facility.admissionLabel': 'ADMISSION FLOW',
  'home.facility.admissionTitle': 'Steps to Enrolment',

  'home.facility.imgAlt': 'Male instructor welcoming a woman with a bag in the entrance hall',
  'home.facility.imgTitle': 'Male instructor welcoming a woman with a bag in the entrance hall',

  // BenefitsSection
  'home.benefits.imgAlt': 'Young male trainee adjusting white gloves beside the wardrobe',
  'home.benefits.imgTitle': 'Young male trainee adjusting white gloves beside the wardrobe',

  // CorporateSection
  'home.corporate.img1Alt': 'A Japanese butler instructor guiding participants in deportment during corporate training',
  'home.corporate.img1Title': 'Corporate Hospitality Training — Deportment & Bearing',
  'home.corporate.img2Alt': 'A Japanese butler instructor demonstrating tea service technique to hotel staff',
  'home.corporate.img2Title': 'Corporate Hospitality Training — Tea Service Practical',

  // CurriculumSection
  'home.curriculum.img1Alt': 'Female instructor explaining by the fireplace as a male trainee takes notes',
  'home.curriculum.img1Title': 'Female instructor explaining by the fireplace as a male trainee takes notes',
  'home.curriculum.img2Alt': "Female trainee adjusting a male instructor's coat sleeve in the dining room",
  'home.curriculum.img2Title': "Female trainee adjusting a male instructor's coat sleeve in the dining room",
  'home.curriculum.img3Alt': 'Young female trainee writing notes at a desk in a wood-paneled study',
  'home.curriculum.img3Title': 'Young female trainee writing notes at a desk in a wood-paneled study',

  // BenefitsSection items
  'home.benefits.item0.title': 'Butler\'s Tool Set',
  'home.benefits.item0.desc': 'A complete set of professional butler tools presented to each student, available for practical use after graduation.',
  'home.benefits.item1.title': 'White Gloves',
  'home.benefits.item1.desc': 'High-quality white gloves included as standard with every course — worn from the very first day as the hallmark of the professional butler.',
  'home.benefits.item2.title': 'Bespoke Waistcoat',
  'home.benefits.item2.desc': 'A made-to-measure academy waistcoat tailored individually for each student.',
  'home.benefits.item3.title': 'Certificate & Association Credential',
  'home.benefits.item3.desc': 'Students who pass the practical graduation examination receive an official credential (Associate / Professional / Master Butler) and certified pin badge recognised by The All Japan Butler Association. \n\n*A private qualification issued by the Association.',
  'home.benefits.item4.title': 'Graduate Career Support (Coming Soon)',
  'home.benefits.item4.desc': 'A planned service to connect graduates with butler-related employment opportunities sourced by The All Japan Butler Association.',

  // AdmissionSteps items
  'home.admission.step0.title': 'Request a Brochure',
  'home.admission.step0.titleEn': 'Request Brochure',
  'home.admission.step0.desc': 'Begin with a brochure request. We will send you detailed information about our courses and the Academy\'s philosophy.',
  'home.admission.step1.title': 'Individual Consultation',
  'home.admission.step1.titleEn': 'Consultation',
  'home.admission.step1.desc': 'Our experienced staff will help you select the course best suited to your goals and background.',
  'home.admission.step2.title': 'Application',
  'home.admission.step2.titleEn': 'Apply',
  'home.admission.step2.desc': 'Once you have chosen your course, please complete the application form. Places are limited and enrolment closes when capacity is reached.',

  // NewsSection items
  'home.news.item3.category': 'Announcement',
  'home.news.item3.title': 'Official website renewed',

  // NewsSection
  'home.news.label': 'NEWS',
  'home.news.title': 'News & Updates',
  'home.news.viewAll': 'View All News',

  // HomeFAQSection
  'home.faq.label': 'FAQ',
  'home.faq.title': 'Frequently Asked Questions',
  'home.faq.viewAll': 'View All Questions',
  'home.faq.q1': 'Can I become a butler with no prior experience?',
  'home.faq.a1': 'Yes. All courses at The Japan Butler Academy welcome complete beginners. \n\nThe Essential Course follows a step-by-step curriculum starting from the fundamental skills, and is open to anyone aged 18 or over regardless of nationality, gender, or background.',
  'home.faq.q2': 'Can I obtain a butler qualification?',
  'home.faq.a2': 'Upon passing the practical examination at the end of each course, you will receive an official credential recognised by The All Japan Butler Association (Certified Associate Butler / Certified Professional Butler / Certified Master Butler) along with a certified pin badge.',
  'home.faq.q3': 'What payment methods are accepted?',
  'home.faq.a3': 'Payment is by bank transfer in full only. Instalment payments and credit cards are not accepted. The payment deadline is 14 days before the course start date.',
  'home.faq.q4': 'Can I attend while working full-time?',
  'home.faq.a4': 'Yes. All courses are held on weekends, so those working on weekdays can attend without difficulty. The Essential Course runs over 1 month (8 days), the Advanced Course over 2 months (12 days), and the Master Course over 3 months (16 days).',
  'home.faq.q5': 'What format do the classes take?',
  'home.faq.a5': 'A hybrid format that combines in-person weekend classes (6 hours per day, four 90-minute sessions) with on-demand preparation and review videos. \n\nYou learn the fundamentals through the videos, so in-person sessions can focus on hands-on practice and questions.',
  'home.faq.q6': 'How many students are in each class?',
  'home.faq.a6': 'A maximum of six students per class, in a small-group format for close, individual guidance. The minimum number required to run a course is three. Places are offered on a first-come, first-served basis.',
  'home.faq.q7': 'Is there an entrance examination?',
  'home.faq.a7': 'There is no entrance examination or selection process. Anyone aged 18 or over may apply, regardless of nationality, gender, or experience, on a first-come, first-served basis (6 places per course).',
  'home.faq.q8': 'Can I take the course entirely online?',
  'home.faq.a8': 'The main hands-on classes are held in person at our Odaiba campus. On-demand videos are available for preparation and review. Our free individual consultation is also available online.',

  // CorporateSection
  'home.corporate.label': 'CORPORATE TRAINING',
  'home.corporate.title': 'Corporate & Group Training',
  'home.corporate.subtitle': 'The Japan Butler Academy also offers hospitality and business etiquette training for companies and organisations. We deliver the refined manners and service principles cultivated by professional butlers as practical business skills for your team.',
  'home.corporate.formatIntro': 'This is an on-site, dispatch-style training programme delivered by our instructors at your workplace. In addition to your own offices, we can also deliver training in an external meeting room, or outdoors and on location (for example, greeting and send-off etiquette, or vehicle boarding assistance), with programmes customised by industry — hotels, clinics, luxury residences, finance, and retail.',
  'home.corporate.brochureCta': 'Request the Corporate Brochure',
  'home.corporate.more': 'We also serve a wide range of industries, including medical and beauty clinics, and department store VIP services.',
  'home.corporate.allIndustries': 'View All Industries',
  'home.corporate.halfDay': 'Half-day from ',
  'home.corporate.halfDayPrice': `¥${incYenOf('ct-single-halfday')}`,
  'home.corporate.fullDay': ' (tax incl.) · Full-day from ',
  'home.corporate.fullDayPrice': `¥${incYenOf('ct-single-fullday')}`,
  'home.corporate.fullDayEnd': ' (tax incl.)',
  'home.corporate.travel': 'On-site delivery nationwide available (travel and accommodation costs billed separately)',
  'home.corporate.cta': 'For Companies: On-Site Training',
  // Industries
  'home.corporate.hotel.name': 'Hotels & Ryokan',
  'home.corporate.hotel.desc': 'From pre-opening training to butler service standards',
  'home.corporate.residence.name': 'Luxury Residences',
  'home.corporate.residence.desc': 'Unifying concierge and front-desk hospitality standards',
  'home.corporate.finance.name': 'Finance & Private Banking',
  'home.corporate.finance.desc': 'Building client trust through refined manner and presence',
  'home.corporate.luxury.name': 'Luxury Sales',
  'home.corporate.luxury.desc': 'Crafting premium consultation experiences for automotive, jewellery, and real estate',
  'home.corporate.auto.name': 'Automotive & Mobility',
  'home.corporate.auto.desc': 'Elevating hospitality at brand experience venues and showrooms',
  'home.corporate.chauffeur.name': 'Chauffeur & VIP Transfer',
  'home.corporate.chauffeur.desc': 'Mastering boarding etiquette, in-vehicle attentiveness, and VIP protocols',

  // FinalCTASection
  'home.cta.label': 'CONTACT',
  'home.cta.title': 'Start with a Brochure Request',
  'home.cta.body1': 'For enquiries about our courses or the admission process,',
  'home.cta.body2': 'please feel free to reach out at any time.',
  'home.cta.brochure': 'Request a Brochure',
  'home.cta.contact': 'Contact Us',
  'home.cta.tel': 'TEL: ',
  'home.cta.telNum': '+81-3-6824-4086',
  'home.cta.mail': 'Email: ',
  'home.cta.mailAddr': 'info@butler-academy.jp',
};

export default home;
